import React from 'react';
import SearchTextInput from 'app/components/SearchTextInput';
import { useTranslation } from 'react-i18next';
import { INSTAGRAM_AUDIO_SEARCH_MAX_LENGTH } from '../../constants';

interface InstagramAudioSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

const InstagramAudioSearchBar = ({
  value,
  onChange,
}: InstagramAudioSearchBarProps) => {
  const { t } = useTranslation();

  return (
    <SearchTextInput
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onClear={() => onChange('')}
      placeholder={t('instagramAudio.searchPlaceholder')}
      maxLength={INSTAGRAM_AUDIO_SEARCH_MAX_LENGTH}
      data-cy="instagram-audio_search-input"
    />
  );
};

export default InstagramAudioSearchBar;
